(function (){
    $(document).on('click','.btn_siguiente', function(){
        let next = $(this).closest('.tab-pane').next();
        let act = $(this).closest('.tab-pane');
        var nexttabname = next.attr('aria-labelledby');
        act.removeClass('active')
        next.tab('show');
        $('#'+nexttabname).tab('show');
    })
})();